import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface ChangelogEntry {
  version: string;
  date: string;
  description: string;
}

const ChangelogModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { markChangelogAsSeen } = useAuth();
  const [changelog, setChangelog] = useState<ChangelogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open) {
      fetch('/changelog.json')
        .then(res => res.json())
        .then(data => {
          setChangelog(data);
          setLoading(false);
        });
    }
  }, [open]);

    const handleClose = async () => {
    try {
      await markChangelogAsSeen();
    } catch (error) {
      console.error('Erro ao marcar changelog como visto:', error);
    }
    onClose();
  };

  if (!open) return null;
  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header text-white" style={{ backgroundColor: '#a2449c' }}>
            <h5 className="modal-title"><i className="fas fa-rocket me-2"></i>Novidades & Changelog</h5>
            <button type="button" className="btn-close btn-close-white" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            {loading ? (
                             <div className="text-center py-5">
                 <div className="spinner-border" style={{ color: '#a2449c' }} role="status"></div>
               </div>
            ) : (
              <div>
                {changelog.map(item => (
                  <div key={item.version} className="mb-5 p-3 border rounded bg-light shadow-sm">
                                         <div className="d-flex align-items-center mb-2">
                       <span className="badge me-2" style={{fontSize: '1rem', backgroundColor: '#a2449c'}}><i className="fas fa-tag me-1"></i> {item.version}</span>
                       <span className="text-muted small"><i className="far fa-calendar-alt me-1"></i>{item.date}</span>
                     </div>
                     <div className="ps-1" style={{fontSize: '1.1rem', whiteSpace: 'pre-line'}}>{item.description}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangelogModal; 